import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
// import { MatSidenav } from '@angular/material';
// import { MatToolbarModule } from '@angular/material/toolbar';

import { ApplicationConstants } from '../../providers/application-constants';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Utils } from '../../providers/utils';
import { BranchSelectComponent } from '../branch-select/branch-select.component';

@Component({
  selector: 'app-user-main',
  templateUrl: './user-main.component.html',
  styleUrls: ['./user-main.component.css']
})


export class UserMainComponent implements OnInit {

  // @ViewChild(MatSidenav)
  // sidenav!: MatSidenav;
  // isMobile= true;
  // isCollapsed = false;
  // panelOpenState = false;
  // isExpanded = true;
  // isShowing = false;

  // public menu ;//= {};
  // branch_exist = true;
  whatsapp_link = '';

  branchDialogRef: MatDialogRef<BranchSelectComponent>;
  constructor(public applicationConstants: ApplicationConstants, public translate: TranslateService,
    private utils: Utils, public dialog: MatDialog, private observer: BreakpointObserver) {

    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
  }

  ngOnInit() {
    // this.observer.observe(['(max-width: 800px)']).subscribe((screenSize) => {
    //   if(screenSize.matches){
    //     this.isMobile = true;
    //   } else {
    //     this.isMobile = false;
    //   }
    // });

    this.whatsapp_link = this.utils.getParamValue('whatsapp_link');

    //if the user has not select a branch yet:
    if (this.applicationConstants.user_info['user_id'] != undefined && this.applicationConstants.user_branch_info.user_branch_id == '0' && 
      !this.applicationConstants.system_expired && this.applicationConstants.param['db_ver'] == this.applicationConstants.app_version) {

      let user_id = this.applicationConstants.user_info['user_id'];
      this.applicationConstants.branch_exist = true;

      //get branch list:
      let query = "SELECT DISTINCT `branch_auth`.`branch_id`, `branch`.* FROM `branch`," +
        " `branch_auth` WHERE `branch`.`status` = '1' AND `branch_auth`.`status` = '1' AND `branch_auth`.`branch_id` =" +
        " `branch`.`branch_id` AND `branch_auth`.`user_id` = '" + user_id + "'";

      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let branch_list = [];
          branch_list = data.data['list'];

          if (branch_list.length > 1) {
            let dialog_data = branch_list;
            this.branchDialogRef = this.dialog.open(BranchSelectComponent, {
              hasBackdrop: false,
              data: dialog_data
            });
            this.branchDialogRef
              .afterClosed()
              .subscribe(result => {
              });
          }
          else if (branch_list.length == 1) {
            this.applicationConstants.user_branch_info.user_branch_id = branch_list['0']['branch_id'];
            this.applicationConstants.user_branch_info.user_branch_name = branch_list['0']['branch_name'];
            this.applicationConstants.user_branch_info.user_branch_name_en = branch_list['0']['branch_name_en'];
            // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
          }
          else
            this.applicationConstants.branch_exist = false;
        });

    }
    // console.log(this.applicationConstants.main_menu);
    // this.menu = this.applicationConstants.main_menu;
    //console.log('1');
  }

  // mouseenter() {
  //   if (!this.isExpanded) {
  //     this.isShowing = true;
  //   }
  // }

  // mouseleave() {
  //   if (!this.isExpanded) {
  //     this.isShowing = false;
  //   }
  // }

  // toggleMenu() {
  //   if(this.isMobile){
  //     this.sidenav.toggle();
  //     this.isCollapsed = false; // On mobile, the menu can never be collapsed
  //   } else {
  //     this.sidenav.open(); // On desktop/tablet, the menu can never be fully closed
  //     this.isCollapsed = !this.isCollapsed;
  //   }
  // }

}
